// Pretvorba LaTeX izraza u običan Unicode tekst (npr. $p = \rho \cdot g \cdot h$ -> p = ρ · g · h)

const GREEK = {
  alpha: "α", beta: "β", gamma: "γ", Gamma: "Γ", delta: "δ", Delta: "Δ",
  epsilon: "ε", varepsilon: "ε", eta: "η", theta: "θ", kappa: "κ",
  lambda: "λ", mu: "μ", nu: "ν", pi: "π", rho: "ρ", sigma: "σ",
  tau: "τ", phi: "φ", varphi: "φ", chi: "χ", psi: "ψ",
  omega: "ω", Omega: "Ω",
};
const SYMBOLS = {
  cdot: "·", times: "×", div: "÷", approx: "≈", sim: "≈",
  le: "≤", leq: "≤", ge: "≥", geq: "≥", ne: "≠", neq: "≠",
  pm: "±", rightarrow: "→", to: "→", Rightarrow: "⇒",
  infty: "∞", degree: "°", circ: "°", propto: "∝",
};
const SUP = { 0: "⁰", 1: "¹", 2: "²", 3: "³", 4: "⁴", 5: "⁵", 6: "⁶", 7: "⁷", 8: "⁸", 9: "⁹", "-": "⁻", "+": "⁺", n: "ⁿ" };
const SUB = { 0: "₀", 1: "₁", 2: "₂", 3: "₃", 4: "₄", 5: "₅", 6: "₆", 7: "₇", 8: "₈", 9: "₉" };

const mapChars = (s, map) => (s.split("").every((c) => map[c]) ? s.split("").map((c) => map[c]).join("") : null);

function commands(expr) {
  expr = expr.replace(/\\frac\{([^{}]+)\}\{([^{}]+)\}/g, "$1/$2");
  expr = expr.replace(/\\sqrt\{([^{}]+)\}/g, "√$1");
  expr = expr.replace(/\\(?:text|mathrm|mathit|mathbf)\{([^{}]*)\}/g, "$1");
  for (const [k, v] of Object.entries({ ...GREEK, ...SYMBOLS })) {
    expr = expr.replace(new RegExp("\\\\" + k + "(?![a-zA-Z])", "g"), v);
  }
  expr = expr.replace(/\\[,;]/g, " ").replace(/\\!/g, "").replace(/\\left|\\right/g, "");
  return expr;
}

function convertExpr(expr) {
  expr = commands(expr);
  expr = expr.replace(/\^\{([^{}]+)\}/g, (m, s) => mapChars(s, SUP) || "^" + s);
  expr = expr.replace(/\^([0-9n+-])/g, (m, s) => SUP[s] || "^" + s);
  expr = expr.replace(/_\{([^{}]+)\}/g, (m, s) => mapChars(s, SUB) || s);
  expr = expr.replace(/_([0-9])/g, (m, s) => SUB[s] || s);
  expr = expr.replace(/\{,\}/g, ",").replace(/[{}]/g, "");
  return expr.replace(/\s+/g, " ").trim();
}

export function cleanMath(text) {
  if (!text || (!text.includes("$") && !text.includes("\\"))) return text;
  let t = text.replace(/\$\$(\S(?:[^$]*\S)?)\$\$/g, (m, e) => convertExpr(e));
  t = t.replace(/\$(\S(?:[^$\n]*\S)?)\$/g, (m, e) => convertExpr(e));
  return commands(t);
}
